import { ApiRoutes } from "@/api/client";
import { createResource, deleteResource, getResource, getResourcePage, updateResource } from "@/api/helpers";
import { ExistingWebhook, PaginationParams, PaginationResponse, Webhook } from "@/types";

const getWebhooks = async (paginationParams: PaginationParams): Promise<PaginationResponse<ExistingWebhook>> => {
  return getResourcePage<ExistingWebhook, { webhooks: ExistingWebhook[] | null }>(
    ApiRoutes.WEBHOOKS,
    paginationParams,
    (response) => response.data.data.webhooks ?? [],
    "Failed to fetch webhooks.",
  );
};

const getWebhook = async (webhookId: ExistingWebhook["id"]): Promise<ExistingWebhook> => {
  return getResource<ExistingWebhook, { webhook: ExistingWebhook }>(
    `${ApiRoutes.WEBHOOKS}/${webhookId}`,
    (response) => response.data.data.webhook,
    "Failed to fetch webhook.",
  );
};

const postWebhook = (webhook: Webhook): Promise<ExistingWebhook> =>
  createResource<Webhook, ExistingWebhook>(
    ApiRoutes.WEBHOOKS,
    webhook,
    "webhook",
    "webhook",
    "Failed to create webhook.",
  );

const deleteWebhook = (webhookId: ExistingWebhook["id"]): Promise<void> =>
  deleteResource(`${ApiRoutes.WEBHOOKS}/${webhookId}`, "Failed to delete webhook.");

const patchWebhook = (webhookId: ExistingWebhook["id"], webhook: Partial<Webhook>): Promise<ExistingWebhook> =>
  updateResource<Webhook, ExistingWebhook>(
    `${ApiRoutes.WEBHOOKS}/${webhookId}`,
    webhook,
    "webhook",
    "webhook",
    "Failed to update webhook.",
  );

const WebhookService = {
  getWebhooks,
  getWebhook,
  postWebhook,
  patchWebhook,
  deleteWebhook,
};

export default WebhookService;
